import FaireEducationHubPage from "@faire/prototype-playground/workspace/jk/education-hub";
import { Route, Switch } from "react-router-dom";

export function JabranKhanRoutes() {
  return (
    <Switch>
      <Route path="/jk/education-hub" component={FaireEducationHubPage} />
    </Switch>
  );
}

export const slug = "jk";
